/* eslint-disable no-var */
import React, { Component } from 'react';
import cIf from 'classnames';


const tr = require('ts-translate-js').default.boundTR;

const buildProductImage = require('@tsinternetsale/common').util.buildProductImage;

export type EventDateInfoProps = {
    id: number,
    name: string,
    productInfoUrl: string,
    productPictureUrl: string,
    dateString: string,
    venueName: string,
    isNewDate: boolean, // When a date is new and must catch the attention of the customer
    isFixedPackage: boolean,
    hidePackageEventDetailLink: boolean,
    selected: boolean,
    seatsAvailability: string,
    isMandatory: boolean,
    homeUrl: string,
    overview: boolean,
    onClick: (id: number, isSelected: boolean, isMandatory: boolean) => void // f(id, isSelected)
};

export type EventDateInfoState = {
    mouseOver: boolean
};

export class EventDateInfo extends Component<EventDateInfoProps, EventDateInfoState> {
    static readonly defaultProps = {
        selected: false,
        productInfoUrl: "",
        productPictureUrl: ""
    };

    constructor(props) {
        super(props);

        this.state = {
            mouseOver: false
        };

        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleMouseIn = this.handleMouseIn.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
    }

    handleItemClick(e) {
        e.preventDefault();
        e.stopPropagation();

        if(!this.props.isFixedPackage)
            this.props.onClick(this.props.id, this.props.selected, this.props.isMandatory);
    }

    handleMouseIn() {
        this.setState({ mouseOver: true });
    }

    handleMouseOut() {
        this.setState({ mouseOver: false });
    }

    // This is very important to prevent the selection of an item when the user click an inner link!
    stopPropagation(e) {
        e.stopPropagation();
    }

    render() {
        /* Ne semble pas utilisé 
        //                     ? <span className="label label-default">tsapp.tr("program.eventdateinfo.newdate")</span>
        //                     : null;
        */

        const checkIcon =
            <div className={cIf( [ "selected-mark", { selected: this.props.selected, "mouse-over": this.state.mouseOver } ] )}>
                <span className="check-icon glyphicon glyphicon-ok"></span>
                <span className="uncheck-icon glyphicon glyphicon-remove"></span>
            </div>;

        let knowMoreLink = null;
        if(this.props.productInfoUrl.length > 0 && !this.props.hidePackageEventDetailLink)
            knowMoreLink = <a href={this.props.productInfoUrl} rel="noopener noreferrer" target="_blank" onClick={this.stopPropagation}>{tr("en savoir plus...")}</a>;

        const itemClickable = !this.props.overview && !this.props.isFixedPackage && this.props.seatsAvailability !== "SEATS_AVAILABILITY_SOLDOUT";

        const clickableEvents = (itemClickable) ? {
            onClick: this.handleItemClick,
            onMouseEnter: this.handleMouseIn,
            onMouseLeave: this.handleMouseOut
        } : null;

        let seatsRemainingInfo;

        const imageUrl = buildProductImage(this.props.homeUrl, {homeSquareImageUrl: this.props.productPictureUrl}, false).productImageUrl;

        if (this.props.seatsAvailability == "SEATS_AVAILABILITY_SOLDOUT")
            seatsRemainingInfo = <h4><span className="label label-warning">{tr("program.eventdateinfo.soldout")}</span></h4>;
            else if (this.props.seatsAvailability == "SEATS_AVAILABILITY_FEW_SEATS")
            seatsRemainingInfo = <h4><span className="label label-info"> {tr("program.eventdateinfo.fewseats")} </span></h4>;

            const content = (
            <div className={cIf( [ "media", "col-md-6", "col-xs-12", { active: this.props.selected, clickable: itemClickable, "mouse-over": this.state.mouseOver } ] )} {...clickableEvents} >
                <div className="media-left">
                    <div className="media-img-block">
                        <img className="media-object" alt="" src={imageUrl} />
                        {checkIcon}
                    </div>
                </div>
                <div className="media-body">
                    <h4 className="media-heading">
                        {this.props.name} <small className="no-wrap">{knowMoreLink}</small>
                    </h4>
                    {seatsRemainingInfo}
                    <p>
                        {this.props.dateString} <br/> {this.props.venueName}
                    </p>
                </div>

            </div>
            );

        return content;
    }
}

